import { combineReducers } from 'redux';
import subjects from './subjects';
import tickets from './tickets';
import ticketForm from './ticketForm';
import files from './files';

export default combineReducers({
  subjects,
  tickets,
  ticketForm,
  files,
});
